module.exports = "/assets/data/d0e10be91a10755d8d191a438f1d8882-BD19.data.json";